/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { DomainCompanyRewardTypeString } from '../../entities/domain/CompanyRewardTypeString'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const domainCompanyRewardTypeStringSchema = z.enum(['percent_from_gmv', 'targets']) as unknown as ToZod<DomainCompanyRewardTypeString>